module.exports = __webpack_public_path__ + "155a3c2f2f8af4ecec59adcfbc067d90.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/follow_a_book.png
// module id = 1559
// module chunks = 0